import React, { Fragment } from "react";

interface IErrorLabel {
  error?: string;
}

function ErrorLabel({ error }: IErrorLabel) {
  return (
    <Fragment>
      {error && (
        <label style={{ color: "red", fontWeight: "bold" }}>{error}</label>
      )}
    </Fragment>
  );
}
export default ErrorLabel;
